import ProfileImage from "./profile.jpg";
import "./DanGNelson.css";

function App() {
  return (
    <div
      id="dangnelson"
      className="d-flex align-items-center justify-content-center pb-3"
      style={{ minHeight: "100%" }}
    >
      <div className="d-flex flex-column" style={{ maxWidth: 350 }}>
        <div className="pb-4 d-flex flex-column align-items-center text-center">
          <div
            className="profile-container position-relative w-75 mb-3 rounded-circle "
            style={{
              paddingBottom: "75%",
              userSelect: "none",
              WebkitUserSelect: "none",
            }}
          >
            <div className="profile-border-thin position-absolute rounded-circle" />
            <div className={"position-absolute "}>
              <img
                src={ProfileImage}
                className="w-100 img-fluid rounded-circle"
                alt="logo"
              />
            </div>
          </div>

          <h1>Dan G Nelson</h1>
          <p className="m-0">
            <i className="fa-fw fa-solid fa-location-dot"></i> Richmond, VA
          </p>
        </div>
        <div className=" d-flex flex-column">
          <a
            href="mailto:dan.g.nelson+com@gmail.com"
            role="button"
            type="button"
            className="btn btn-lg btn-outline-dark mb-2"
          >
            <i className="fa-fw fa-solid fa-envelope"></i> Email
          </a>
        </div>
      </div>
    </div>
  );
}

export default App;
